var _circle, _circle2, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 39,
    viewBox: "0 0 38 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.9995,
    cy: 19.2769,
    r: 18.9995,
    fill: "url(#paint0_linear_5296_8913)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.9995,
    cy: 19.2769,
    r: 18.9995,
    fill: "url(#paint1_linear_5296_8913)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2598 18.8296L16.7237 24.2032L26.7409 14.3516",
    stroke: "white",
    strokeWidth: 3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5296_8913",
    x1: 0,
    y1: 0.277344,
    x2: 37.9991,
    y2: 38.2764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0DD36B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0DBA5F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5296_8913",
    x1: 0,
    y1: 0.277344,
    x2: 37.9991,
    y2: 38.2764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0DD36B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0DBA5F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickAlert);
export default __webpack_public_path__ + "static/media/tick-alert.ac4f2f9224b3d1cadf1a95dffbdde33f.svg";
export { ForwardRef as ReactComponent };